import React from 'react';
import {
  AgeListContainer,
  SectionCircle,
  VaccinationSection,
  VaccinationTitle,
  VaccinationTrackerImg,
} from './styled';
import { vaccinationWeekList } from './util';
import VaccinationWekkList from './VaccinationWekkList';
import { useRouter } from 'next/router';

export default function VaccinationToolIndex() {
  const router = useRouter();
  return (
    <>
      <img
        src="https://images.myloapp.in/NestJsUploads/1757508366683-Banner-4-(1).webp"
        alt="Flu Vaccine form banner"
        width="100%"
        height="100%"
        onClick={() => router.push('/form/73')}
        style={{ cursor: 'pointer' }}
      />
      <VaccinationSection>
        <VaccinationTitle>Vaccination Tracker</VaccinationTitle>
        <SectionCircle>
          <VaccinationTrackerImg
            src="https://images.myloapp.in/NestJsUploads/1672837730641-vaccinationImage.webp"
            alt="vaccination Tracker"
          />
        </SectionCircle>
        <AgeListContainer>
          {vaccinationWeekList?.map((data, index) => {
            return <VaccinationWekkList data={data} key={index} />;
          })}
        </AgeListContainer>
      </VaccinationSection>
    </>
  );
}
